module.exports = __webpack_public_path__ + "img/loan-calculator.68a773b9.svg";